function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.75 1.875L1.96042 1.42143L0.937633 0.946944L1.27257 2.02353L1.75 1.875ZM3.5 7.5L3.97743 7.64853L4.02364 7.5L3.97743 7.35147L3.5 7.5ZM1.75 13.125L1.27257 12.9765L0.937633 14.0531L1.96042 13.5786L1.75 13.125ZM13.875 7.5L14.0854 7.95357L15.0631 7.5L14.0854 7.04643L13.875 7.5ZM1.27257 2.02353L3.02257 7.64853L3.97743 7.35147L2.22743 1.72647L1.27257 2.02353ZM3.02257 7.35147L1.27257 12.9765L2.22743 13.2735L3.97743 7.64853L3.02257 7.35147ZM1.96042 13.5786L14.0854 7.95357L13.6646 7.04643L1.53958 12.6714L1.96042 13.5786ZM14.0854 7.04643L1.96042 1.42143L1.53958 2.32857L13.6646 7.95357L14.0854 7.04643ZM3.5 8H13.375V7H3.5V8ZM3.5 8H13.375V7H3.5V8Z",
  fill: "white"
});

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.80924c39.svg";
export { ForwardRef as ReactComponent };